import * as Types from '../../../graphql.generated';

import { ListingFragment } from './Listing.fragments.generated';
import { gql } from '@apollo/client';
import { ListingFragmentDoc } from './Listing.fragments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {};
export type ListingQueryVariables = Types.Exact<{
    listingId: Types.Scalars['Int'];
    include?: Types.Maybe<Array<Types.Maybe<Types.ListingInclusion>>>;
}>;

export type ListingQuery = { __typename?: 'Query' } & {
    listingDetails?: Types.Maybe<
        | ({ __typename?: 'ListingData' } & ListingFragment)
        | ({ __typename?: 'ListingResultError' } & Pick<
              Types.ListingResultError,
              'errorCode'
          >)
    >;
};

export const ListingDocument = gql`
    query listing($listingId: Int!, $include: [ListingInclusion]) {
        listingDetails(id: $listingId, include: $include) {
            ... on ListingData {
                ...LISTING
            }
            ... on ListingResultError {
                errorCode
            }
        }
    }
    ${ListingFragmentDoc}
`;

/**
 * __useListingQuery__
 *
 * To run a query within a React component, call `useListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingQuery({
 *   variables: {
 *      listingId: // value for 'listingId'
 *      include: // value for 'include'
 *   },
 * });
 */
export function useListingQuery(
    baseOptions: Apollo.QueryHookOptions<ListingQuery, ListingQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<ListingQuery, ListingQueryVariables>(
        ListingDocument,
        options
    );
}
export function useListingLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        ListingQuery,
        ListingQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<ListingQuery, ListingQueryVariables>(
        ListingDocument,
        options
    );
}
export type ListingQueryHookResult = ReturnType<typeof useListingQuery>;
export type ListingLazyQueryHookResult = ReturnType<typeof useListingLazyQuery>;
export type ListingQueryResult = Apollo.QueryResult<
    ListingQuery,
    ListingQueryVariables
>;
